import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6807e885"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "PlayListDetail"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ListDetailTop = _resolveComponent("ListDetailTop");

  var _component_ListDetailNav = _resolveComponent("ListDetailNav");

  var _component_ListDetail = _resolveComponent("ListDetail");

  var _component_Comment = _resolveComponent("Comment");

  var _component_Loading = _resolveComponent("Loading");

  return _ctx.route.params.id == _ctx.listDetail.id ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 歌单头部详情区域 "), _createVNode(_component_ListDetailTop, {
    detailTopInfo: _ctx.listDetail,
    detailType: "歌单"
  }, null, 8
  /* PROPS */
  , ["detailTopInfo"]), _createCommentVNode(" 歌单导航 "), _createVNode(_component_ListDetailNav, {
    navList: _ctx.navList,
    commentTotal: _ctx.commentList.total,
    onTitleClick: _ctx.titleClick
  }, null, 8
  /* PROPS */
  , ["navList", "commentTotal", "onTitleClick"]), _createCommentVNode(" 歌曲列表 "), _ctx.isShow == 0 ? (_openBlock(), _createBlock(_component_ListDetail, {
    key: 0,
    musicList: _ctx.listDetail.tracks
  }, null, 8
  /* PROPS */
  , ["musicList"])) : _ctx.isShow == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createCommentVNode(" 评论页面 "), _createVNode(_component_Comment, {
    commentInfo: _ctx.commentList,
    pageInfo: _ctx.listCmtResData,
    onChangeCurrent: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["commentInfo", "pageInfo", "onChangeCurrent"])], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  )) : _createCommentVNode("v-if", true)])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }));
}